<template>
  <div>
    <div v-if="isEditMode && !isColumnLimitExceeded && !isOther" class="delivery-add-button">
      <tw-button type="secondary" size="medium" icon="plus" @click="addRow">Add</tw-button>

      <!-- <el-dropdown v-show="selectedRowIndex !== null" trigger="click" placement="bottom-start" @command="copyCommand">
        <tw-button style="margin-left:10px" type="secondary" size="medium" icon="menu">Menu</tw-button>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="scheduledToDelivery">Copy 1st [Scheduled Date Time] to [Scheduled Delivery Date]</el-dropdown-item>
          <el-dropdown-item command="scheduledToDevanning">Copy 1st [Scheduled Date Time] to [Scheduled Devanning Date]</el-dropdown-item>
          <el-dropdown-item command="actualDeliveryToDelivery">Copy 1st [Actual Delivery Date] to [Delivery Date]</el-dropdown-item>
          <el-dropdown-item command="actualDeliveryToDevanning">Copy 1st [Actual Delivery Date] to [Devanning Date]</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown> -->
    </div>
    <div class="delivery" :class="{ 'modal-table': isModal}">
      <div class="table_scroll">
        <el-table :data="visibleDeliveryOrderList" class="delivery-table" max-height="400" @row-click="rowClick">
          <el-table-column v-if="isEditMode && !isOther" width="45" align="center" fixed="left">
            <template #default="scope">
              <el-button icon="el-icon-close" @click="removeRow(scope.$index)" circle size="mini" tabindex="-1" />
            </template>
          </el-table-column>
          <el-table-column v-for="col in deliveryTableSchema" :key="col.key" :label="$t(`Label.${col.label}`)" :width="getColumnwidth(col)" :fixed="col.fixed || false" :render-header="col.selectAll ? selectAllHeader(col) : undefined">
            <template #default="scope">
              <tw-process-group-list-edit-delivery-table-item
                :item="col"
                :value="scope.row.deliveryOrderGrp"
                @input="val => updateRow(scope.$index, val)"
                :is-edit-mode="isEditMode && !isOther"
                :row-index=scope.$index
              />
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <div v-if="isColumnLimitExceeded" style="color: red; margin: 0px 10px 10px 2.5%">
      Maximum number of records [{{ maxColumns }}] exceeded.
    </div>
    <div v-if="!isEditMode && !isModal" class="delivery-modal-link">
      <div class="modal-text" @click="$emit('open-modal')">
        {{ deliveryOrder.deliveryOrderList.length > maxDisplayRow ? 'More...' : 'Expand...'}}
      </div>
    </div>
  </div>
</template>

<script>
import { UNDISCLOSED_FLAG } from 'lib-tw-common';
import TwProcessGroupListEditDeliveryTableItem from '@/components/molecules/TwProcessGroupListEditDeliveryTableItem.vue';
import deliveryTableSchema from '@/dictionaries/deliveryTableSchema.json';
import TwButton from '@/components/atoms/TwButton';

export default {
  name: 'TwProcessGroupListEditDeliveryTable',
  inject: ['s'],
  components: {
    TwProcessGroupListEditDeliveryTableItem,
    TwButton
  },
  props: {
    value: Object,
    isOther: Boolean,
    isEditMode: Boolean,
    isModal: Boolean
  },
  data() {
    return {
      selectAllState: {},
      maxColumns: 100,
      maxDisplayRow: 5,
      UNDISCLOSED_FLAG: UNDISCLOSED_FLAG,
      selectedRowIndex: null
    };
  },
  created() {
    if (!this.value?.deliveryOrder?.deliveryOrderList || this.value.deliveryOrder.deliveryOrderList.length === 0) {
      this.deliveryOrder = {
        deliveryOrderList: [this.createRow()]
      };
    }
  },
  computed: {
    deliveryTableSchema() {
      return deliveryTableSchema.filter(col => {
        if (this.isOther && col.otherInvisible) {
          return false;
        }
        return true;
      });
    },
    deliveryOrder: {
      get() {
        if (this.isOther) {
          const source = this.s.res.deliveryOrder.otherDeliveryOrderList;
          return {
            deliveryOrderList: source || []
          };
        }
        if (!this.isEditMode) {
          const source = this.s.res.deliveryOrder.deliveryOrderList;
          return {
            deliveryOrderList: source || []
          };
        } 
        return this.value.deliveryOrder
      },
      set(val) {
        this.$emit('input', {
          ...this.value,
          deliveryOrder: val
        })
      }
    },
    isColumnLimitExceeded() {
      return this.deliveryOrder.deliveryOrderList.length >= this.maxColumns;
    },
    visibleDeliveryOrderList() {
      const list = this.deliveryOrder.deliveryOrderList || [];
      const updateList = list.map(item => {
        if (item.deliveryOrderGrp && item.deliveryOrderGrp.doUndisclosedFlag == null) {
          item.deliveryOrderGrp.doUndisclosedFlag = UNDISCLOSED_FLAG.OFF;
        }
        return item;
      });
      return (this.isEditMode || this.isModal) ? updateList : updateList.slice(0, 5);
    }
  },
  watch: {
    'deliveryOrder.deliveryOrderList': {
      handler(newVal) {
        if (Array.isArray(newVal) && newVal.length === 0 && this.isEditMode) {
          this.deliveryOrder = {
            deliveryOrderList: [this.createRow()]
          };
        }
      },
      immediate: true
    }
  },
  methods: {
    updateRow(index, updatedGrp) {
      const newList = [...this.deliveryOrder.deliveryOrderList];
        newList[index] = {
          ...newList[index],
          deliveryOrderGrp: updatedGrp
        };
        this.deliveryOrder = {
          ...this.deliveryOrder,
          deliveryOrderList: newList
        };
    },
    removeRow(index) {
      const newList = [...this.deliveryOrder.deliveryOrderList];
      newList.splice(index, 1);
      this.deliveryOrder = {
        ...this.deliveryOrder,
        deliveryOrderList: newList
      };
    },
    addRow() {
      const newList = [...this.deliveryOrder.deliveryOrderList, this.createRow()];
        this.deliveryOrder = {
          ...this.deliveryOrder,
          deliveryOrderList: newList
        };
    },
    createRow() {
      return {
        deliveryOrderGrp: {
          doDeliveryNo: '',
          doContainerSize: '',
          doContainerType: '',
          doUnitType: '',
          doPlaceName: '',
          doScheduledDatetime: null,
          doOltFlag: null,
          doRemarks: '',
          doArranged: null,
          doCyPickupDate: null,
          doActualDate: null,
          doUndisclosedFlag: 0
        }
      };
    },
    selectAllHeader(col) {
      return (h) => {
        const canSelctAll = this.isEditMode && !this.isOther;
        if (!canSelctAll) {
          return h('span', this.$t(`Label.${col.label}`));
        }
        return h('div', {
          style: {
            display: 'flex',
            alignItems: 'center',
            gap: '4px'
          }
        }, [
          h('el-checkbox', {
            props: {
              value: this.selectAllState[col.key] === 1
            },
            on: {
              input: val => {
                const flg = val ? 1 : 0;
                this.$set(this.selectAllState, col.key, flg);
                           
                const updatedList = this.deliveryOrder.deliveryOrderList.map(row => {
                  const updatedGrp = {
                    ...row.deliveryOrderGrp,
                    [col.key]: flg
                  };
                  return {
                    ...row,
                    deliveryOrderGrp: updatedGrp
                  };
                });

                this.deliveryOrder = {
                  ...this.deliveryOrder,
                  deliveryOrderList: updatedList
                };
              }
            }
          }),
          h('span', this.$t(`Label.${col.label}`))
        ]);
      };
    },
    getColumnwidth(col) {
      if (col.key === 'doContainerType' && !this.isEditMode) {
        return 170;
      }
      return col.width;
    },
    rowClick(row) {
      this.selectedRowIndex = this.deliveryOrder.deliveryOrderList.indexOf(row);
    },
    // copyCommand(command) {
    //   const rowIndex = this.selectedRowIndex;
    //   const row = this.deliveryOrder.deliveryOrderList[rowIndex].deliveryOrderGrp;

    //   switch (command) {
    //     case 'scheduledToDelivery':
    //       this.$set(this.value.linkageTransportation.logisticsDeliveryGrp, 'scheduledDeliveryDate', row.doScheduledDatetime);
    //       break;
    //     case 'scheduledToDevanning':
    //       this.$set(this.value.linkageImportCustoms.devanningGrp, 'scheduledDevanningDate', row.doScheduledDatetime);
    //       break;
    //     case 'actualDeliveryToDelivery':
    //       this.$set(this.value.linkageTransportation.logisticsDeliveryGrp, 'deliveryDate', row.doActualDate);
    //       break;
    //     case 'actualDeliveryToDevanning':
    //       this.$set(this.value.linkageImportCustoms.devanningGrp, 'actualDevanningDate', row.doActualDate);
    //       break;
    //   }
    // }
  }
};
</script>
<style lang='scss' scoped>
  .delivery {
    width: 950px;
  }
  .delivery-add-button {
    margin: 0px 2.5% 20px 2.5%;
    display: flex;
    justify-content: flex-end;
  }
</style>
<style lang='scss'>
  .delivery-table {
    background-color: #fff;
    border-collapse: collapse;
    border-color: gray;
    width: 95% !important;
    margin-right: 2.5%;
    margin-left: 2.5%;
    margin-bottom: 5px;
    margin-top: 10px;

    th {
      position: sticky;
      font-weight: bold;
      font-size: 12px;
      line-height: 7px;
      word-break: break-word;
      padding: 4px 5px;
      border-left: 1px solid $color_gray_300;
      border-right: 1px solid $color_gray_300;
      background: $color_dark_blue;
      color: white;
      z-index: 2;
            
        .el-checkbox__inner {
          border: $color_dark_blue;
        }
    }
    td {
      font-weight: normal;
      font-size: 14px;
      line-height: 22px;
      white-space: nowrap;
      padding: 0;
      border: 1px solid #EDEDF4;
      border-bottom: 1;
    }
    .cell {
      padding: 0;
    }
    .el-input__inner,
    .el-textarea__inner,
    .el-select .el-input__inner {
      background-color: #fff;
      box-shadow: none;
      border-radius: 0;
      border-color: #FFF;
      color: #111;
      resize: none;
    }
    .el-input__count {
      background: white;
    }
  }
  .delivery-modal-link {
    text-align: center;
    margin-top: 10px;
    color: $color_dark_blue;
    cursor: pointer;
  }
  .modal-table {
    width: 100% !important;
  }
  .el-dropdown-menu.el-popper {
    z-index: 2001 !important;
  }
</style>
